<template>
  <div class="block">
    <el-tag>选择账户： </el-tag>
    <div class="block">
      <el-cascader
        v-model="userUalue"
        :options="options1"
        filterable></el-cascader>
    </div>
    <el-divider direction="vertical"></el-divider>
    <el-tag>选择汇总方式：</el-tag>

    <el-select v-model="value" placeholder="请选择">
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
    <el-divider direction="vertical"></el-divider>
    <el-tag>选择层级：</el-tag>
    <el-select v-model="values" placeholder="请选择">
      <el-option
        v-for="items in level"
        :key="items.value"
        :label="items.label"
        :value="items.value">
      </el-option>
    </el-select>

    <el-divider direction="vertical"></el-divider>
    <el-tag>输入起止日期：</el-tag>

    <el-date-picker
      v-model="value1"
      type="daterange"
      align="right"
      unlink-panels
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      value-format="yyyyMMdd"
      :picker-options="pickerOptions"
      @change="chooseTimeRange">
    </el-date-picker>
    <el-button type="primary" v-on:click="exportExcel" round>导出</el-button>
    <el-button type="primary" v-on:click="getDataList" :disabled="isDisable" round>查询</el-button>
    <el-divider></el-divider>

    <el-table
      v-loading="loading"
      element-loading-text="拼命查询中..."
      stripe
      :default-sort = "{prop: 'date', order: 'descending'}"
      :data="datas"
      id="exportTab"
      :summary-method="getSummaries"
      show-summary
      style="width: 100%">
      <el-table-column
        sortable
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        fixed
        prop="campaignName"
        label="计划名称"
        width="180">
      </el-table-column>

      <el-table-column
        sortable
        v-if="['GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="groupId"
        label="广告组ID"
        width="100">
      </el-table-column>
      <el-table-column
        sortable
        v-if="['GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="groupName"
        label="广告组名称"
        width="200">
      </el-table-column>
      <el-table-column
        sortable
        v-if="['ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="advertisementId"
        width="120"
        label="广告ID">
      </el-table-column>
      <el-table-column
        v-if="['ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="advertisementName"
        label="广告名称"
        width="300">
      </el-table-column>
      <el-table-column
        v-if="['CREATIVE'].includes(this.values)"
        prop="creativeId"
        label="创意ID">
      </el-table-column>
      <el-table-column
        v-if="['CREATIVE'].includes(this.values)"
        sortable
        width="120"
        prop="placeType"
        label="广告位类型">
      </el-table-column>
      <el-table-column
        v-if="['GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        sortable
        width="120"
        prop="cvType"
        label="转化类型">
      </el-table-column>
      <el-table-column
        v-if="['ACCOUNT'].includes(this.values)"
        prop="reportDate"

        label="按天维度查询时返回">
      </el-table-column>
      <el-table-column
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="uuid"
        width="180"
        label="账户id">
      </el-table-column>
      <el-table-column
        sortable
        prop="nameid"

        label="名称">
      </el-table-column>
      <el-table-column
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="campaignId"

        label="计划id">
      </el-table-column>
      <el-table-column
        sortable
        :formatter="rule"
        prop="balance"

        label="现金余额">
      </el-table-column>
      <el-table-column
        sortable
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        label="撞线警告">
        <template slot-scope="scope">
          <el-tag type="danger" v-if="scope.row.flag">警告警告 </el-tag>
          <el-tag type="success" v-else-if="!scope.row.flag">平安 </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        sortable

        prop="showCount"
        label="曝光量"
      >
      </el-table-column>
      <el-table-column
        sortable

        prop="clickCount"
        label="点击量">
      </el-table-column>
      <el-table-column
        prop="CTR"

        label="点击均价">
      </el-table-column>
      <el-table-column
        sortable
        :formatter="rule"

        prop="spent"

        label="花费">
      </el-table-column>
      <el-table-column
        sortable

        prop="formsubmitCount"
        label="表单提交量">
      </el-table-column>
      <el-table-column
        sortable

        prop="but"
        label="表单成本"
      >
      </el-table-column>
      <el-table-column
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        sortable
        prop="dailyBudget"
        :formatter="rule1"
        label="日限额">
      </el-table-column>
<!--      <el-table-column-->
<!--        prop="customPayCount"-->
<!--        label="自定义付费数(按计费时间)">-->
<!--      </el-table-column>-->
<!--      <el-table-column-->
<!--        prop="zdyff"-->
<!--        label="自定义付费数成本">-->
<!--      </el-table-column>-->
<!--      <el-table-column-->
<!--        prop="reactivation"-->
<!--        label="自定义拉活数(按计费时间)">-->
<!--      </el-table-column>-->
<!--      <el-table-column-->
<!--        prop="zdylh"-->
<!--        label="自定义拉活数成本">-->
<!--      </el-table-column>-->
<!--      <el-table-column-->
<!--        prop="customRetainCount"-->
<!--        label="自定义次留">-->
<!--      </el-table-column>-->
<!--      <el-table-column-->
<!--        prop="zdycl"-->
<!--        label="自定义次留成本">-->
<!--      </el-table-column>-->
<!--      <el-table-column-->
<!--        sortable-->
<!--        prop="CVR"-->
<!--        :formatter="ChangeToPercentage"-->
<!--        label="转化率">-->
<!--      </el-table-column>-->
<!--      sortable-->
<!--      <el-table-column-->
<!--        prop="CLR"-->
<!--        :formatter="ChangeToPercentage"-->
<!--        label="次留率">-->
<!--      </el-table-column>-->
      <el-table-column
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        sortable
        fixed="right"
        label="计划状态"
        prop="pauseState"

      >
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.pauseState"
            :active-value="0"
            :inactive-value="1"
            active-color="#13ce66"
            inactive-color="#ff4949"
            @change="changeSwitch($event,scope.row,scope.$index)"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        width="100">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" v-if="flag" type="text" size="small">查看</el-button>
          <el-button @click="edit(scope.row)" v-if="dingshi" type="text" size="small">定时</el-button>
          <el-button @click="edit1(scope.row)"  v-if="xiane" type="text" size="small">限额</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-drawer
      title="时段成本"
      :visible.sync="table"
      direction="rtl"
      size="50%">
      <el-table :data="HourList"
                v-loading="loading"
      >
        <el-table-column property="reportTime" label="日期" width="150"></el-table-column>
        <el-table-column property="campaignName" label="计划名称" width="200"></el-table-column>
        <el-table-column property="nameid" label="名称"></el-table-column>
        <el-table-column property="spent" label="花费"></el-table-column>
        <el-table-column property="formsubmitCount" label="表单提交量" width="200"></el-table-column>
        <el-table-column property="chengben" label="成本" width="200"></el-table-column>
      </el-table>
    </el-drawer>
    <el-dialog title="修改开启时间" :visible.sync="dialog">

      <el-tabs v-model="activeName" @tab-click="boo" type="border-card">
        <el-tab-pane name="first" label="长期投放" >
          <span class="demonstration">开启日期</span>
          <el-date-picker
            v-model="value3"
            type="date"
            align="right"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-tab-pane>
        <el-tab-pane  name="second" label="指定开始和结束日期">
          <el-date-picker
            v-model="value1"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            @change="chooseTimeRange">
          </el-date-picker>
        </el-tab-pane>

      </el-tabs>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog = false">取 消</el-button>
        <el-button type="primary" @click="updateTime(form)">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改日限额" width="500px"  :visible.sync="dialog1">

      <el-tabs v-model="activeName" @tab-click="boo" type="border-card">
        <el-tab-pane name="first" label="不限" >
          <el-tag>不限制任何额度</el-tag>
        </el-tab-pane>
        <el-tab-pane  name="second" label="自定义">
          <el-input v-model="money" style="width: 30%" placeholder="请输入内容"></el-input><el-tag>元/天</el-tag>

        </el-tab-pane>

      </el-tabs>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog1 = false">取 消</el-button>
        <el-button type="primary" @click="updateEd(form)">确 定</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
export default {


  data() {
    return {

      loading:false,
      isDisable:false,
      userUalue:'',
      options1: [
        {
          value: 'sl',
          label: '推啊',
          // children: [{
          //   value: 'tui',
          //   label: '推啊',
          // },
          // ]
        },
      ],
      options: [{
        value: 'DAY',
        label: '按天汇总'
      }, {
        value: 'HOUR',
        label: '按小时汇总'
      }, {
        value: 'SUMMARY',
        label: '汇总'
      }
      ],
      value: '',
      level: [{
        value: 'ACCOUNT',
        label: '账户层级'
      }, {
        value: 'CAMPAIGN',
        label: '计划层级'
      }, {
        value: 'GROUP',
        label: '广告组层级'
      },
        {
          value: 'ADVERTISEMENT',
          label: '广告层级'
        },
        {
          value: 'CREATIVE',
          label: '创意层级'
        }],
      /*
      小邱
       */
      xiaowei:['1586d2894696aeb13c6b23cd86826b0caa2212428c88d706d1794f4700d51343','aec54f42e9b9e599ebe0832f36d8864170ef1fe3665345f455c177551f1e16b6'],
      tui:['45e47a3f514facfade91',
        'd589a7109fba0bbd6ce0',
        '0338a09528024baaf122',
        '8c0e9f1bcc9a5e7720da',
        'a885c3b4ab634b28a5ef',
        '4c05b56e8065f14970f4',
        '36b86b05b9501864f599',
        '2cf4f923f356518bf5a2',
        'e6a6443987603c5be0b2',
        '83f36dd53b607e74d3f8',
        'f48a80d2480b6ed825dc',
        'a92b7646e1b2ea21d4a5',
        '2bb549cc78932d6e91e6',
        '9ceb4770811fc8a6fa50',
        '63c3f9ffb0076420ce7b',
        '6a1cdf875ed55c5d68c5',
        'b348f1aba27315715f25',
        '31fe589dc8f3af20ffee',
        '7eb5eb8f77222f4a80e6',
        '314cf60e9f1734efc6d5',
        'b09d74b63388e67e0271',
        '62f93eb24f1aac102377',
        '0ce9959d04428137d3dd',
        '664b887d65817cc04f40',
        '1edf64b5274b3a73f278',
        '24a6452162bb4d6deac5',
        'a1ee5831b6b8148ed6db',
        '519df6909cef5b31c312',
        'bb3d5ac299072e1555e4',
        '49f9749f7ee2f2b403a9',


      ],
      tui1:[
        '6477a9e649e4a7454ff1',
        '16f9f11f8a414a939476',
        'cec3ae8c697d33c24a65',
        'e0d613c718523ce6b80a',
        'e1c03a1178f76efe7a3c',
        'f9a67bb0a15316a8c21e',
        'dd470c57112e54d3d353',
        'a519d6422f744c98d192',
        '230166e7cfdbad3cf86e',
        '886449d939c2ed2168aa',
        '3af41423d7bf937e2a6a',
        '76d158fcbf5559050074',
        'be5e102eb2bbe7b0aca0',
        '8e9da6187358bb1afa46',
        '3899de63aeff48a57496',
        'df59dde79b4a07355723',
        'db045e772be1cac4ccd4',
        '376c755ecc58844b8ace',
        'd51ec67cd9dc580df9b1',
        '56bc028309ac93451eea',
      ],

      values: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      money:200,
      value3:'',
      time:'',
      value1: '',
      value2: '',
      datas:[],
      datadata:[],
      temp:[],
      temp1:[],
      temp2:[],
      startDate:'20220701',
      endDate:'20220710',
      namedata:[],
      datanums:[
        {
          nuMshowCount:0,
          nuMclickCount:0,
          nuMspent:0,
          nuMformsubmitCount:0,
          nuMdisGeneralBalance:0,
          nuMbalance:0,
          nuMcustomPayCount:0,
          nuMreactivation:0,
          nuMcustomRetainCount:0
        }
      ],
      ctrJson:[{
        flag:false,
        nameid:'',
        CTR:0,
        CVR:0,
        CLR:0,
        but:0,
        zdycl:0,
        zdyff:0,
        zdylh:0

      }],
      playCode:[],
      TempData:[],
      table:false,
      dialog: false,
      dialog1:false,
      HourList:[],
      Hourmap:new Map,
      sums:0,
      flag:true,
      form:[],
      group:{},
      kaiguan:0,
      activeName: 'first',
      grouplist:{},
      dingshi:true,
      xiane:true,
      sks:''


    }
  },

  methods:{
//面板状态
    boo(tab) {
      if(tab.name==="first"){
        this.kaiguan=0
      }else if (tab.name==="second"){
        this.kaiguan=1
      }

    },

    //限额方法提交
    updateEd(){
      if (this.grouplist.userId==="d58d2e06d91f1fcc1734"){
        if(this.kaiguan===0){
          let t1={
            id:this.grouplist.campaignId,
            dailyBudget:-1,
            token:'6871c87dc96f817bb95b0790a54de176e582e5156d0f69485f1f4b1733e018f7',
            adid:this.grouplist.userId
          }
          this.PostMoeny(t1)

        }else if (this.kaiguan===1){
          let t1={
            id:this.grouplist.campaignId,
            dailyBudget:this.money*100000,
            token:'6871c87dc96f817bb95b0790a54de176e582e5156d0f69485f1f4b1733e018f7',
            adid:this.grouplist.userId
          }
          this.PostMoeny(t1)
        }
      }else {
        if(this.kaiguan===0){
          let t1={
            id:this.grouplist.campaignId,
            dailyBudget:-1,
            token:this.sks,
            adid:this.grouplist.userId
          }
          this.PostMoeny(t1)

        }else if (this.kaiguan===1){
          let t1={
            id:this.grouplist.campaignId,
            dailyBudget:this.money*100000,
            token:this.sks,
            adid:this.grouplist.userId
          }
          this.PostMoeny(t1)
        }
      }


      this.dialog1=false

    },

    //投放时间方法提交
    updateTime(){
      let endtime='2038-01-19'
      if (this.grouplist.userId==="d58d2e06d91f1fcc1734"){
        if(this.kaiguan===0){
          //发送
          console.log(this.value3)
          let pams={
            ids:this.grouplist.groudId,
            startDate:this.value3,
            endDate:endtime,
            token:'6871c87dc96f817bb95b0790a54de176e582e5156d0f69485f1f4b1733e018f7',
            adid:this.grouplist.userId
          }
          this.PostGroup(pams)
        }else if (this.kaiguan===1){
          let pams={
            ids:this.grouplist.groudId,
            startDate:this.value2.at(0),
            endDate:this.value2.at(1),
            token:'6871c87dc96f817bb95b0790a54de176e582e5156d0f69485f1f4b1733e018f7',
            adid:this.grouplist.userId
          }
          this.PostGroup(pams)
        }
      }
      else {
        if(this.kaiguan===0){
          //发送
          console.log(this.value3)
          let pams={
            ids:this.grouplist.groudId,
            startDate:this.value3,
            endDate:endtime,
            token:this.sks,
            adid:this.grouplist.userId
          }
          this.PostGroup(pams)
        }else if (this.kaiguan===1){
          let pams={
            ids:this.grouplist.groudId,
            startDate:this.value2.at(0),
            endDate:this.value2.at(1),
            token:this.sks,
            adid:this.grouplist.userId
          }
          this.PostGroup(pams)
        }
      }

      this.dialog = false
    },

    //限额
    edit1(row){
      console.log(row)
      this.grouplist={}
      this.grouplist={
        campaignId:row.campaignId,
        userId:row.userId,
      }
      this.dialog1=true
    },

    //投放日期
    edit(row){
      this.grouplist={}
      this.grouplist={
        userId:row.userId,
        groudId:row.groupId
      }

      this.dialog=true
      return row
    },

    //显示表单
    handleClick(row){
      this.HourList=[],
        this.TempData=[],
        this.TempData.push(row)
      for (let key=1;key<=this.Hourmap.size;key++){
        // console.log(this.Hourmap.get(key))
        for (let keys=0;keys<this.Hourmap.get(key).length;keys++){
          // console.log(this.TempData.campaignId)
          if(this.Hourmap.get(key)[keys].campaignId===this.TempData[0].campaignId){

            this.HourList.push(this.Hourmap.get(key)[keys])
          }
        }
      }
      let str=[{
        nameid:'',
        balance:'',
        chengben:''
      }];
      str[0].nameid=this.TempData[0].nameid;
      str[0].balance=this.TempData[0].balance;
      for(let i in this.HourList){
        console.log(this.HourList[i].spent)
        console.log(this.HourList[i].formsubmitCount)
        if (this.HourList[i].formsubmitCount===0){
          str[0].chengben=this.HourList[i].spent
          str[0].chengben = parseFloat(str[0].chengben).toFixed(6);
          let tempVal3 = parseFloat( str[0].chengben).toFixed(5);
          str[0].chengben = tempVal3.substring(0,tempVal3.length - 1);
        }else {
          str[0].chengben=this.HourList[i].spent/this.HourList[i].formsubmitCount
          str[0].chengben = parseFloat(str[0].chengben).toFixed(6);
          let tempVal3 = parseFloat( str[0].chengben).toFixed(5);
          str[0].chengben = tempVal3.substring(0,tempVal3.length - 1);
        }


        this.HourList[i]=this.hb(this.HourList[i],str[0])
      }
      this.table=true



      // get发送请求获取本条的投放时间
      // 生成折线图


    },

    //切换开关
    changeSwitch(value,row,index){
      let time1 = parseInt(new Date().getTime()) + '';
      let nonce = Math.round(Math.random() * 100000000000)
      const { id,pauseState,userId} = row
      let params = {
        userId:userId,
        id:id,
        pauseState: pauseState ? '1' : '0'  // 三元运算符  类似于if else
      };

      this.$axios.post('api/openapi/v1/ad/campaign/pause/toggle?access_token='+this.sks+'&timestamp='+
        time1+'&nonce='+nonce+'&advertiser_id='+params.userId,{
        ids:params.id,
        startAndStop:params.pauseState
      }).then(async res=> {
        if (res.data.code === 0) {
          this.$message.success(`${pauseState ? '已停用' : '已启用'}`)
        }
      })

    },

    //限额显示的规则
    rule1(row,column){
      if (row[column.property]===-1){
        return '未限额'
      }else {
        var percent = row[column.property]/100000
        return percent
      }
    },

    //总汇规则
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      if (this.values==="ACCOUNT"){ //账户层级
        let a=0;
        console.log(param.data)
        console.log(param.data.length)
        columns.forEach((column, index) => {

          if (index === 0) {
            sums[index] = '总汇';
            return;
          }

          if (index === 8) {
            sums[index] = sums[index-2]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }

          if(index===5){

            sums[index] = sums[index]/param.data.length;
            sums[index]= sums[index].toFixed(2);
            sums[index]=sums[index]
            return;
          }
          if (index === 10) {
            sums[index] = sums[index-4]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 12) {
            sums[index] = sums[index-6]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 14) {
            sums[index] = sums[index-8]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 15) {

            return;

          }

          if (index === 16) {

            return;

          }


          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value)) ) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);

            sums[index] = sums[index].toFixed(2) + "";
          } else {
            sums[index] = '';
          }

        });
        return sums;
      }else if(this.values==="CAMPAIGN"){ //计划层级
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '总汇';
            return;
          }


          if (index === 8) {
            sums[index] = sums[index-2]/sums[index-1];
            sums[index]=sums[index].toFixed(2);
            sums[index]=sums[index]/10
            sums[index]= sums[index]+'%'
            sums[index]=sums[index]
            return;

          }
          if (index === 11) {
            sums[index] = sums[index-4]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }     if (index === 12) {

            return;

          }
          if (index === 14) {
            sums[index] = sums[index-5]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }

          if (index === 16) {
            sums[index] = sums[index-7]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 18) {
            sums[index] = sums[index-9]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 19) {

            return;

          }if (index === 20) {

            return;

          }

          if (index === 21) {

            return;

          }


          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value)) ) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);

            sums[index] = sums[index].toFixed(2) + "";
          } else {
            sums[index] = '';
          }
        });
        return sums;
      }else if(this.values==="GROUP"){ //广告组层级
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '总汇';
            return;
          }  if (index === 9) {
            sums[index] = sums[index-2]/sums[index-1];
            sums[index] =  sums[index].toFixed(2) ;
            return;

          }
          if (index === 6) {
            sums[index] = sums[index-1]/sums[index-2];
            sums[index]=sums[index]*100
            sums[index]=sums[index].toFixed(2);
            sums[index]= sums[index]+'%'
            return;

          }
          if (index === 11) {
            sums[index] = sums[index-4]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 13) {
            sums[index] = sums[index-6]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 15) {
            sums[index] = sums[index-8]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 16) {
            sums[index] = sums[index-8]/sums[index-11];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]*100+'%'
            return;

          }
          if (index === 17) {
            sums[index] = sums[index-5]/sums[index-9];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]*100+'%'
            return;

          }



          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value)) ) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);

            sums[index] = sums[index].toFixed(2) + "";
          } else {
            sums[index] = '';
          }
        });
        return sums;
      }
    },
    //导出表单api
    exportExcel () {
      /* generate workbook object from table */
      var xlsxParam = { raw: false } // 导出的内容只做解析，不进行格式转换
      var wb = XLSX.utils.table_to_book(document.querySelector('#exportTab'), xlsxParam)

      var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
      try {
        FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '数据导出.xlsx')
      } catch (e) {
        if (typeof console !== 'undefined') {
          console.log(e, wbout)
        }
      }
      return wbout
    },

    //规则
    rule(row,column){
      if (row[column.property]===undefined){
        return null
      }else {
        var percent = (row[column.property]).toFixed(2)
        return percent
      }
    },

    //查询时间选择器函数
    ChangeToPercentage: function(row, column) {
      if (row[column.property]===undefined){
        return null
      }else {
        var percent = (row[column.property] * 100).toFixed(2) + '%'
        return percent
      }

    },

    // 获取时间戳，获取时间选择器时间
    chooseTimeRange(value1){
      this.time = parseInt(new Date().getTime()) + '';
      console.log(this.time)
      this.value2=value1;

    },

    //渲染data、数据处理通用方法
    windowList(){
      //渲染页
      this.temp=JSON.parse(JSON.stringify(this.datadata))
      this.temp1=JSON.parse(JSON.stringify(this.namedata))
      this.temp3=JSON.parse(JSON.stringify(this.playCode))
      for (let key = 0; key < this.temp.length; key++) {
        this.ctrJson[0].flag=false;
        let t=0;
        this.ctrJson[0].nameid=this.temp1[key].name
        this.temp1[key].balance=this.temp1[key].balance+this.temp1[key].disGeneralBalance
        this.temp1[key].balance = this.temp1[key].balance / 100000

        this.temp2[key] = this.hb(this.temp1[key], this.temp[key])
        if (this.temp2[key].spent===0){
          this.ctrJson[0].but=0
        }else if (this.temp2[key].formsubmitCount===0){
          this.ctrJson[0].but=this.temp2[key].spent
        }else {
          this.ctrJson[0].but = this.temp2[key].spent / this.temp2[key].formsubmitCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat(this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
        }
        this.ctrJson[0].CTR=this.temp2[key].spent/this.temp2[key].clickCount
        this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
        let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
        this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);

        this.ctrJson[0].CVR = this.temp2[key].formsubmitCount / this.temp2[key].clickCount
        this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
        let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
        this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
        this.ctrJson[0].CLR = this.temp2[key].customRetainCount / this.temp2[key].formsubmitCount
        this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
        let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
        this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);

        if (this.temp2[key].spent===0){
          this.ctrJson[0].zdycl=0
        }else if (this.temp2[key].customRetainCount===0){
          this.ctrJson[0].zdycl=this.temp2[key].spent
        }else {

          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customRetainCount;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
        }




        if (this.temp2[key].spent===0){
          this.ctrJson[0].zdyff=0
        }else if (this.temp2[key].customPayCount===0){
          this.ctrJson[0].zdyff=this.temp2[key].spent
        }else {
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
        }


        if (this.temp2[key].spent===0){
          this.ctrJson[0].zdylh=0
        }else if (this.temp2[key].reactivation===0){
          this.ctrJson[0].zdylh=this.temp2[key].spent
        }else {
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].reactivation;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);
        }




        //  限额提醒代码
        if(this.temp3[key].dailyBudget!=-1){
          t=this.temp3[key].dailyBudget/100000
          t=t*0.8
          if (this.temp2[key].spent>=t){
            this.ctrJson[0].flag=true;
          }
        }
        this.temp2[key] = this.hb(this.temp2[key], this.ctrJson[0])
        this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])
      }
      this.temp2=JSON.parse(JSON.stringify(this.temp2))
      this.datas=this.temp2
      console.log(this.temp2)
      this.isDisable = false
      if (this.value==="DAY"){
        this.flag=false;
        if (this.values==="GROUP"){
          this.dingshi=true;
          this.xiane=false;
        }else if(this.values==="CAMPAIGN" ){
          this.dingshi=false;
          this.xiane=true;
        }else if (this.values==="ACCOUNT"){
          this.dingshi=false;
          this.xiane=false
        }
      }else if (this.value==="HOUR"){
        this.flag=true;
        if (this.values==="GROUP"){
          this.dingshi=false;
          this.xiane=false;
        }else if(this.values==="CAMPAIGN" ){
          this.dingshi=false;
          this.xiane=false;
        }else if (this.values==="ACCOUNT"){
          this.dingshi=false;
          this.xiane=false
        }
      }

      this.loading=false
    },

    //查询广告效果api
    async PostListQuery(parms){

      let nonce = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/adstatement/summary/query?access_token=' + parms.token + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid[parms.a], {
        startDate: parms.startDate,
        endDate: parms.endDate,
        pageIndex: "1",
        pageSize: "100",
        summaryType: parms.summaryType,
        level: parms.level
      }).then(async resp => {
        if (resp.data.code!==60806){  if (resp.data.data.items !=null){
          if (this.value==="HOUR"){
            // 存取小时的数据[]
            this.sums=this.sums+1;
            console.log(resp.data.data.items)
            this.Hourmap.set(this.sums,resp.data.data.items)
            let arr=[];
            let map=new Map;
            for(let key in resp.data.data.items){
              var time=new Date(resp.data.data.items[key].reportTime)
              let reTimeHour=time.getHours(); //获取返回整点时间
              var date=new Date()
              let hour=date.getHours();  // 获取当前时间
              if (hour===reTimeHour){
                arr.push(key)   //定位现在整时位置
                map.set(key,resp.data.data.items[key])// 记录下现在的数据
              }
            }
            for (let keys in arr){

              this.datadata.push(map.get(arr[keys]))
              let obj={
                ids:resp.data.data.items[arr[keys]].campaignId,
                lengths:arr.length
              }
              let pams=Object.assign(obj,parms)
              await this.PostListplayCode(pams)
            }
            let obj1={
              lengths:arr.length
            }
            parms=Object.assign(obj1,parms)
            await this.GetListUserId(parms);

          }else{
            console.log(resp.data)

            for (let b=0;b<resp.data.data.items.length;b++){

              this.datadata.push(resp.data.data.items[b])
              let obj={
                ids:resp.data.data.items[b].campaignId,
                lengths:resp.data.data.items.length
              }
              let pams=Object.assign(obj,parms)
              await this.PostListplayCode(pams)
            }
            let obj1={
              lengths:resp.data.data.items.length
            }
            parms=Object.assign(obj1,parms)
            await this.GetListUserId(parms);

          }

        }}

      })

    },

    //修改限额api
    async PostGroup(pams){
      console.log(pams)
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/group/batchEditDate?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "ids":pams.ids,
          "startDate":pams.startDate,
          "endDate":pams.endDate
        }).then(resp=>{

        console.log(resp.data)
        if (resp.data.code===70111){
          this.$notify.error({
            title: '错误',
            message: '修改投放日期失败，请检查日期是否错误'
          });
        }else {
          this.$notify({
            title: '成功',
            message: '修改投放日期成功',
            type: 'success'
          });
        }

      })


    },

    //修改投放日期api
    async PostMoeny(pams){
      console.log(pams)
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/campaign/editDailyBudget?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "id":pams.id,
          "dailyBudget":pams.dailyBudget,

        }).then(resp=>{

        console.log(resp.data)
        if (resp.data.code===70111){
          this.$notify.error({
            title: '错误',
            message: '修改限额失败，请检测限额是否错误'
          });
        }else {
          this.$notify({
            title: '成功',
            message: '修改限额成功',
            type: 'success'
          });
          this.getDataList()
        }

      })


    },
    //查询账号信息api
    async GetListUserId(parms){
      let nonce = Math.round(Math.random() * 100000000000)
      await this.$axios.get('api/openapi/v1/account/fetch?access_token=' + parms.token + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid[parms.a])
        .then(async res => {
            if (res.data.message == '请求成功') {
              this.$message.success("正在查询第"+parms.a+"条")
              //测试
              if (this.value==="HOUR"){
                for (let e=0;e<parms.lengths;e++){
                  this.namedata.push(res.data.data)
                }
              }else{
                for (let e=0;e<parms.lengths;e++){
                  this.namedata.push(res.data.data)
                }
              }
            } else {
            }
          }

        )
    },
    // 查询计划状态api
    async PostListplayCode(pams){
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/campaign/pageInfo?access_token='+ pams.token + '&timestamp=' + this.time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid[pams.a],
        {
          "ids":pams.ids,
        }).then(resps=>{
        if (resps.data.data.list===undefined){
          this.playCode.push({pauseState:1})
        }else {
          console.log(resps.data.data.list[0])
          this.playCode.push(resps.data.data.list[0])
        }
      })
    },
    hb(jsonbject1, jsonbject2) {
      var resultJsonObject = {};
      for (var attr in jsonbject1) {
        resultJsonObject[attr] = jsonbject1[attr];
      }
      for (var attr in jsonbject2) {
        resultJsonObject[attr] = jsonbject2[attr];
      }
      return resultJsonObject;
    },

    getDataList() {

      this.time = parseInt(new Date().getTime()) + '';
      this.datanums[0].nuMshowCount=0
      this.datanums[0].nuMclickCount=0
      this.datanums[0].nuMspent=0
      this.datanums[0].nuMformsubmitCount=0
      this.datanums[0].nuMbalance=0
      this.datanums[0].nuMdisGeneralBalance=0
      this.datanums[0].nuMcustomPayCount=0
      this.datanums[0].nuMreactivation=0
      this.datanums[0].nuMcustomRetainCount=0
      this.datas=null
      this.datadata=[]
      this.namedata=[]
      this.playCode=[]
      this.temp2=[]
      this.temp1=[]
      this.temp=[]
      console.log(this.userUalue[0])
      console.log(this.userUalue[1])
      if(this.userUalue[0]==="sl" && this.value!=="" && this.value1!==""){
        this.isDisable = true
        this.loading=true
        this.TimeChangeto1();
      }else {
        alert("请选择数据")
      }

    },

    async TimeChangeto1 () {
      console.log("看到我了")
      console.log(this.userUalue[1])
      if (this.userUalue[0]==="sl"){
        this.sks=this.xiaowei[0]
        this.sums=0;
        for (let a = 0; a < this.tui.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.tui
          }
          await this.PostListQuery(parms)
        }
        this.sks=this.xiaowei[1]
        this.sums=0;
        for (let a = 0; a < this.tui1.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.tui1
          }
          await this.PostListQuery(parms)
        }

        this.windowList()
      }

    },


  },
  created () {  },
}
</script>

























// WEBPACK FOOTER //
// src/components/wei.vue